module.exports = __webpack_public_path__ + "img/marker_four_cyan1.acd51f3e.png";